import { KeyboardArrowDownOutlinedIcon } from 'icons/materialIcons';
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import UpgradeSnackBar from 'components/common/notification/UpgradeSnackBar';

const ChooseFontField = () => {

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Function to open the Snackbar
  const handleOpen = () => {
    setOpen(true);
  };

  // Function to close the Snackbar
  const handleClose = () => {
    setOpen(false);
  };

  const tempCardId = "245435454";
  // Function to navigate to the subscribe page
  const handleSubscribe = () => {
    handleClose(); // Close the Snackbar before navigating
    navigate(`/dashboard/subscribe`);
  };


  return (
    <Box sx={{ marginTop: 3 }}>
      {/* Label positioned outside and left-aligned */}
      <Typography
        variant="body2"
        sx={{
          fontSize: '0.8rem',
          fontWeight: 600,
          color: "#4f4f4f",
          marginBottom: "10px",
          textAlign: 'left' // Left-align the label
        }}
      >
        Choose Font
      </Typography>

      {/* Container with colored background */}
      <Box sx={{ backgroundColor: "#f7f7f7", padding: 2 }}>
        {/* Inner Box with White Background and Border */}
        <Box
          onClick={handleOpen}
          sx={{
            backgroundColor: "#ffffff",
            border: '1px solid #dbdbdb',
            padding: 2,
            borderRadius: "6px",
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer', // Change cursor to pointer on hover
            justifyContent: 'space-between'

            // Space between items
          }}
        >
          {/* Blue Box with Text */}
          <Box
            sx={{
              backgroundColor: "#2aaff7",
              padding: '6px 8px',
              borderRadius: '4px',
              marginRight: '10px',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontSize: '0.7rem', fontWeight: 600, color: "#ffffff" }}
            >
              DEFAULT
            </Typography>
          </Box>

          {/* Icon at the end of the white box */}
          <KeyboardArrowDownOutlinedIcon sx={{ color: '#9e9e9e' }} /> {/* Light gray color */}

        </Box>

        {/* Smaller text below the white box */}
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.7rem',
            fontWeight: 400,
            color: "#4f4f4f",
            marginTop: "10px",
            textAlign: 'center' // Center the text
          }}
        >
          Custom fonts are available with the Pro Version.
        </Typography>
      </Box>
      {/* Passing the navigation handler to UpgradeSnackBar */}
      <UpgradeSnackBar open={open} handleClose={handleClose} handleSubscribe={handleSubscribe} />
    </Box>
  );
};

export default ChooseFontField;
